import {useDrugsCategoryContext} from '@/shared/contexts/drugs-category'
import {Badge, Tabs} from '@chakra-ui/react'
import {useTranslate} from '@tolgee/react'
import {LuFlaskConical, LuHistory, LuInfo} from 'react-icons/lu'

export function DrugsCategoryDrawerTabsList() {
  const {t} = useTranslate('common')
  const {category} = useDrugsCategoryContext()

  return (
    <Tabs.List>
      <Tabs.Trigger value="about" data-e2e="about-trigger">
        <LuInfo />
        {t('about')}
      </Tabs.Trigger>

      <Tabs.Trigger value="substances" data-e2e="substances-trigger">
        <LuFlaskConical />
        {t('substances')}
        <Badge size="xs">{category?.drugCatalogItemsCategories?.length || 0}</Badge>
      </Tabs.Trigger>

      <Tabs.Trigger value="history" data-e2e="history-trigger">
        <LuHistory />
        {t('history')}
      </Tabs.Trigger>
    </Tabs.List>
  )
}
